import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CreateNewPasswordPage } from '../LoginPage/CreateNewPasswordPage';
import { LoginPage } from '../LoginPage/LoginPage';
import { ResetPasswordPage } from '../LoginPage/ResetPasswordPage';
import {Layout} from './Layout';
import {Session} from "../../types/Session";
import {Toaster} from "react-hot-toast";
interface Props {
  session: Session;
}
export const GuestPages: React.ComponentType<Props> = ({session}) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#2c65de',
      },
      secondary: {
        main: '#256861',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>

          <Route path="forgot-password" element={<ResetPasswordPage />} />
          <Route
            path="password-reset/:passwordResetKey"
            element={<CreateNewPasswordPage />}
          />

          <Route
            path="/"
            element={<Layout />}
          >
            <Route path="login" element={<LoginPage />} />
            <Route path="*" element={<LoginPage />} />
          </Route>
        </Routes>
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </ThemeProvider>
  );
};
